import React, { useEffect, useRef, useState } from "react";
import NavigationDrawer from "../../components/navigationDrawer";
import CustomBar from "../../components/customBar";
import AppContainer from "../../components/containers/AppContainer";
import {
  Avatar,
  Button,
  Chip,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import { APP_ICONS, APP_IMAGES } from "../../assets";
import SuspendDialog from "../../components/dialog/SuspendDialog";
import ChangePasswordDialog from "./changPassward";
import LockIcon from "@mui/icons-material/Lock";
import { fetchAdminData } from "../../services/adminFn";
import AppLoader from "../../components/loader/loader";

const RenderUsersData = ({ field, value }) => {
  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      gap={1}
      flexWrap={"wrap"}
      sx={{
        padding: "8px 16px",
        borderRadius: "8px",
        backgroundColor: "customColor.background",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        transition: "background-color 0.3s ease",
        "&:hover": {
          backgroundColor: "customColor.hoverBackground",
        },
      }}
    >
      <Typography
        variant="body1"
        fontWeight={600}
        sx={{
          color: "customColor.primaryText",
          textTransform: "capitalize",
          fontSize: "16px",
        }}
      >
        {field}:{" "}
      </Typography>
      <Typography
        sx={{
          color: "customColor.secondaryText",
          fontSize: "14px",
          fontStyle: "italic",
        }}
      >
        {value}
      </Typography>
    </Stack>
  );
};

const returnStatusColor = (status) => {
  if (status === "Active")
    return {
      color: "customColor.malachite",
      bgColor: "customColor.blueRomance",
    };
  if (status === "Inactive")
    return {
      color: "customColor.gray",
      bgColor: "customColor.alto",
    };
};

const UserProfilePage = () => {
  const openSuspendDialog = useRef();
  const openChangePasswordDialog = useRef();
  const userStatus = "Inactive";
  const [adminData, setAdminData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    handleFetchAdminData();
  }, []);
  const handleSuspendUser = async () => {
    openSuspendDialog.current.closeDialog();
  };
  const handleFetchAdminData = async () => {
    setLoading(true);

    try {
      const response = await fetchAdminData();
      if (response.status === 200) {
        setAdminData(response.data?.data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error, "error");
      setLoading(false);
    }
  };

  return (
    <NavigationDrawer>
      <CustomBar title={"USERS PROFILE (ONLY VIEW) "} />
      <AppLoader isVisible={loading} />
      <AppContainer
        styleProps={{
          p: 2,
          borderRadius: "6px",
        }}
      >
        <Stack alignItems={"center"} gap={1} mb={5}>
          <Avatar
            src={APP_IMAGES.dumyUserImg}
            sx={{
              height: 88,
              width: 88,
            }}
          />
          <Typography fontSize={"1.375rem"} fontWeight={500}>
            {adminData?.username}
          </Typography>
          <Chip
            label={"Active"}
            sx={{
              borderRadius: "8px",
              backgroundColor: returnStatusColor(userStatus)?.bgColor,
              color: returnStatusColor(userStatus)?.color,
            }}
          />
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ width: "100%" }}
        >
          <Typography fontSize={"1.5rem"} fontWeight={700}>
            Detail
          </Typography>

          <Button
            sx={{ mb: 3, width: "190px" }}
            variant="contained"
            onClick={() => {
              openChangePasswordDialog.current.openDialog();
            }}
          >
            <LockIcon sx={{ mr: 1, fontSize: "16px" }} />
            Change Password
          </Button>
        </Stack>
        <Divider />
        <Stack mt={1} gap={0.6}>
          <RenderUsersData field={"Username"} value={adminData?.username} />
          <RenderUsersData field={"Email"} value={adminData?.email} />
          <RenderUsersData field={"Status"} value={"Active"} />
        </Stack>
      </AppContainer>

      <SuspendDialog
        ref={openSuspendDialog}
        handleSuspend={handleSuspendUser}
      />
      <ChangePasswordDialog ref={openChangePasswordDialog} />
    </NavigationDrawer>
  );
};

export default UserProfilePage;
